import React from "react";

const ImageCard = ({ item, styles }) => {
  const baseUrl = process.env.REACT_APP_API_URL;
  const coloum_value = JSON.parse(item?.coloum_value);
  const fonts = styles?.filter((item) => item.coloum_name === "fonts")?.[0];
  const fontValue = fonts?.coloum_value && JSON.parse(fonts?.coloum_value);

  return (
    <>
      {coloum_value?.url ? (
        <a href={coloum_value?.url} target="_blank" rel="noreferrer">
          <div className="flex flex-col items-center justify-center gap-[5px] md:gap-[10px]">
            <img
              src={`${
                coloum_value?.name
                  ? baseUrl + "/profile/" + coloum_value?.name
                  : ""
              }`}
              className="md:min-w-[330px] md:min-h-[330px] md:w-[330px] md:h-[330px] md:max-w-[330px] md:max-h-[330px] min-w-[155px] min-h-[155px] w-[155px] h-[155px] max-w-[155px] max-h-[155px] rounded-lg object-cover"
              alt={coloum_value?.altDescription || "..."}
              title={coloum_value?.altDescription || "Image"}
            />
            {coloum_value?.description && (
              <p
                style={{
                  color: fontValue?.fontColor,
                  fontFamily: fontValue?.fontType?.value,
                }}
                className={`text-center text-small4 md:text-small1 capitalize font-${fontValue?.fontType?.value}`}
              >
                {coloum_value?.description}
              </p>
            )}
          </div>
        </a>
      ) : (
        <div className="flex flex-col items-center justify-center gap-[5px] md:gap-[10px]">
          { coloum_value?.name && <img
            src={`${ baseUrl + "/profile/" + coloum_value?.name}`}
            className="md:min-w-[330px] md:min-h-[330px] md:w-[330px] md:h-[330px] md:max-w-[330px] md:max-h-[330px] min-w-[155px] min-h-[155px] w-[155px] h-[155px] max-w-[155px] max-h-[155px] rounded-lg object-cover"
            alt={coloum_value?.altDescription || "..."}
            title={coloum_value?.altDescription || "Image"}
          />}
          {coloum_value?.description && (
            <p
              style={{
                color: fontValue?.fontColor,
                fontFamily: fontValue?.fontType?.value,
              }}
              className={`text-center text-small4 md:text-small1 capitalize font-${fontValue?.fontType?.value}`}
            >
              {coloum_value?.description}
            </p>
          )}
        </div>
      )}
    </>
  );
};

export default ImageCard;
